/* LEGAL-NOTICE
   © Copyright 2018 - Quid Informatica S.p.A. - All Rights Reserved
   https://quidinfo.it/qinetic/licence.html - "Quid Consumer Lending Platform"
   Deposito SIAE n. 012702 del 26 Luglio 2018
LEGAL-NOTICE */
import {
  Directive,
  OnInit,
  TemplateRef,
  ViewContainerRef
} from '@angular/core';
import { AppService } from '@core/services/app/app.service';

@Directive({
  selector: '[appIfDemo]'
})
export class IfDemoDirective implements OnInit {
  constructor(
    private templateRef: TemplateRef<any>,
    private vcRef: ViewContainerRef,
    private appService: AppService
  ) {}

  ngOnInit() {
    this.updateView();
  }

  /**
   * mi mostra/nasconde l'elemento se sono o non sono in modalità demo
   */
  private updateView(): void {
    if (this.appService.isDemoActive()) {
      this.vcRef.createEmbeddedView(this.templateRef);
    } else {
      this.vcRef.clear();
    }
  }
}
